import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators";
import { ifDefined } from 'lit/directives/if-defined.js';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';

import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from '@webs/components-library/theming';

@customElement("webs-article-one-column")
export class ArticleOneColumn extends LitElement {
  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    typographyStyles,
    containerStyles,
    css`

      .m-article-one-column h4 {
        font-family: var(--font-family-base);
        font-size: 1.25rem;
        font-weight: var(--font-weight-base);
        color: var(--color-dark-grey);
      }
      .m-article-one-column ::slotted(p),
      .m-article-one-column ::slotted(a),
      .m-article-one-column ::slotted(li) {
        font-family: var(--font-family-base);
        font-size: 1rem;
        font-weight: var(--font-weight-base);
        color: var(--color-dark-grey);
      }
    `,
  ];

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property()
  id: string;

  protected render(): unknown {
    return html`
    <section id="${ifDefined(this.id)}" class="m-article-one-column ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
      <div part="container" class="container container--small">
        <div class="rich-text-container"><slot></slot></div>
      </div>
    </section>
    `;
  }
}
